import { inject } from '@angular/core';
import { AlertService } from './alert';
import { MaskService } from './mask';
import { SpinService } from './spin';
import { ToastService } from './toast';
import { TranslateService } from './translate';

export class BaseService {
  protected _alert = inject(AlertService);
  protected _mask = inject(MaskService);
  protected _spin = inject(SpinService);
  protected _toast = inject(ToastService);
  protected _translate = inject(TranslateService);
}
